module.exports = __webpack_public_path__ + "static/media/2젠더-올리버튼은계집애래요.66ede44e.mp3";